<template>
    <ul :class="['authorization-hours-list', direction]">
        <li v-for="(item, index) in durations" :key="index" class="authorization-hours">
            <span class="authorization-hours__label">{{ item.category }}:</span> {{ item.credits }} {{ authorizationLabel }}
        </li>
    </ul>
</template>

<script>
    import config from 'services/config'

    export default {
        name: 'totem-authorization-hours',
        props: {
            durations: Array,
            direction: {
                type: String,
                validator: (prop) => [ 'row', 'column' ].includes(prop),
                default: 'column'
            }
        },
        computed: {
            authorizationLabel () {
                if (config.appLanguage === 'no') {
                    return 'oppdateringstimer'
                }
            }
        }

    }
</script>

<style lang="scss" scoped>

    .authorization-hours-list {
        gap: 6px;
        display: flex;
        align-items: flex-start;

        &.column {
            flex-direction: column;
        }

        &.row {
            flex-direction: row;
        }
    }

    .authorization-hours {
        font-family: PlusJakartaSans-Regular, sans-serif;
        font-size: 1.2rem;
        min-height: 20px;
        color: $tuatara;
        background: $medium_blue;
        display: inline-block;
        border-radius: 16px;
        padding: 3px 10px;

        &__label {
            font-family: PlusJakartaSans-SemiBold, sans-serif;
        }
    }
</style>
